import Stats from 'three/examples/jsm/libs/stats.module.js';
interface StatsModuleOptions {
  containerId: string;
  type?: number;
  style?: {
    position?: string;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
  };
}

export class StatsModule {
  stats?: Stats;

  constructor(option: StatsModuleOptions) {
    if (!option?.containerId) {
      throw new Error('containerId is required');
    }
    this.init(option);
  }

  init(option: StatsModuleOptions): void {
    const container: HTMLElement | null = document.getElementById(option.containerId);
    if (!container) {
      throw new Error(`Container with ID ${option.containerId} not found`);
    }
    this.stats = new Stats();
    this.stats.showPanel(option?.type || 0);
    option?.style?.position && (this.stats.dom.style.position = option?.style?.position || 'absolute');
    option?.style?.top && (this.stats.dom.style.top = option?.style?.top);
    option?.style?.left && (this.stats.dom.style.left = option?.style?.left);
    option?.style?.right && (this.stats.dom.style.right = option?.style?.right);
    option?.style?.bottom && (this.stats.dom.style.bottom = option?.style?.bottom);
    this.stats.dom.style.display = 'none';
    container.appendChild(this.stats.dom);
    console.log(this.stats.dom, option);
  }

  hide(): void {
    this.stats!.dom.style.display = 'none';
  }

  show(): void {
    this.stats!.dom.style.display = 'block';
  }
}
